import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { environment } from 'src/environments/environment';
import { Messages } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';


export interface spotData {
  name: string;
  mobile: string;
  ws_opt_in: boolean;
}


@Component({
  selector: 'app-add-spot-driver',
  templateUrl: './add-spot-driver.component.html',
  styleUrls: ['./add-spot-driver.component.scss']
})
export class AddSpotDriverComponent implements OnInit {

  spotDriverData: spotData = {
    name: '',
    mobile: '',
    ws_opt_in: false,
  };

  spinner = false;
  checked = false;
  showLoader = false;
  messages = new Messages();
  defaultVehicle: any;
  editDriver = false;


  constructor(private dialog: MatDialogRef<AddSpotDriverComponent>, private valid: ValidationService, private snackbar: SnackbarService,
    private http: HttpService, private translate: TranslateService, @Inject(MAT_DIALOG_DATA) private parentData: any) { }

  ngOnInit() {
  }

  validate(data) {
    if (!this.valid.isEmpty(this.spotDriverData.name) && !this.valid.isEmpty(this.spotDriverData.mobile)) {
      if (!this.valid.isMobile(this.spotDriverData.mobile)) {
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.addSpotDriver.mobile'), '', 'err');
        return false;
      }
    } else {
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.addSpotDriver.allDetails'), '', 'err');
      return false;
    }
    return true;
  }

  addSpotDriver() {

    const valid = this.validate(this.spotDriverData);

    const reAssign: any = {
      shipment_id: this.parentData.shipment_id,
      driver_mobile: this.spotDriverData.mobile,
      driver_name: this.spotDriverData.name,
      ws_opt_in: this.spotDriverData.ws_opt_in
    };

    if (valid) {
      this.showLoader = true;
      this.http.post('shipment/re_assign_driver', reAssign).subscribe(
        (data: any) => {

          if (data.statusCode === 200) {
            this.showLoader = false;
            if (this.editDriver) {
              this.snackbar.openSnackBar(this.translate.instant('MESSAGE.DRIVERS.SPOT_ON.EDIT_SUCCESS'), '');
            } else {
              this.snackbar.openSnackBar(this.translate.instant('MESSAGE.DRIVERS.SPOT_ON.ADD_SUCCESS'), '');
            }
            this.dialog.close(data);
          }
        },
        (err: any) => {

          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  closeDialog() {
    this.dialog.close();
  }

}
